import api from './client'

/** POST /api/auth/telegram/ — WebApp initData */
export const telegramLogin = (initData) =>
  api.post('/api/auth/telegram/', { init_data: initData })

/** POST /api/auth/telegram/widget/ — Login Widget data */
export const telegramWidgetLogin = (widgetData) =>
  api.post('/api/auth/telegram/widget/', widgetData)

/** POST /api/auth/telegram/oidc/ — "Log in with Telegram" OIDC code exchange */
export const telegramOidcLogin = (code, redirectUri, codeVerifier) =>
  api.post('/api/auth/telegram/oidc/', { code, redirect_uri: redirectUri, code_verifier: codeVerifier })

/** GET /api/auth/me/ */
export const getMe = (config) => api.get('/api/auth/me/', config)

/** GET /api/auth/providers/ — which social logins the backend is configured for */
export const getAuthProviders = (config) => api.get('/api/auth/providers/', config)

/** POST /api/auth/google/ — { id_token } from Google Identity Services */
export const googleLogin = (idToken) =>
  api.post('/api/auth/google/', { id_token: idToken })

/** POST /api/auth/google/link/ — attach a Google identity to the current (authenticated) account */
export const linkGoogleAccount = (idToken) =>
  api.post('/api/auth/google/link/', { id_token: idToken })

/** POST /api/auth/telegram/link/ — attach a Telegram identity to the current (authenticated) account */
export const linkTelegramAccount = (code, redirectUri, codeVerifier) =>
  api.post('/api/auth/telegram/link/', { code, redirect_uri: redirectUri, code_verifier: codeVerifier })

/** POST /api/auth/guest/ — { full_name, age, gender } */
export const guestLogin = (full_name, age, gender) =>
  api.post('/api/auth/guest/', { full_name, age, gender })

/** POST /api/auth/token/ — standard username/password login */
export const login = (username, password) =>
  api.post('/api/auth/token/', { username, password })

/** POST /api/auth/register/ - register new student */
export const register = (username, password, full_name, email = '') =>
  api.post('/api/auth/register/', { username, password, full_name, email })

/** PATCH /api/auth/me/ — update full_name, email, or avatar (FormData for avatar) */
export const updateProfile = (data) => {
  if (data instanceof FormData) {
    return api.patch('/api/auth/me/', data, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
  return api.patch('/api/auth/me/', data)
}

/** POST /api/auth/change-password/ */
export const changePassword = (new_password) =>
  api.post('/api/auth/change-password/', { new_password })

/** DELETE /api/auth/me/ — permanently delete the authenticated user's account */
export const deleteAccount = () => api.delete('/api/auth/me/')


/** GET /api/exams/by-code/:code/ — public exam lookup by join code */
export const getExamByCode = (code) => api.get(`/api/exams/by-code/${code}/`)

/** POST /api/auth/telegram/merge/ — link Telegram identity to existing account */
export const mergeTelegramAccount = (username, password) =>
  api.post('/api/auth/telegram/merge/', { username, password })
